import type * as go from 'gojs';
import { getDiagram } from '../goDiagram';

type PasteLocations = Record<string, { x: number; y: number }>;

export const getTopNode = (nodes: go.ObjectData[]) =>
  nodes.reduce((acc: go.ObjectData | null, node) => {
    if (node.isPanel) {
      return acc;
    }

    if (!acc) {
      return node;
    }

    const [x, y] = node.loc.split(' ').map((v: string) => parseInt(v));
    const [a, b] = acc.loc.split(' ').map((v: string) => parseInt(v));

    if (a > x && b > y) {
      return node;
    }

    return acc;
  }, null);

/**
 * Return node locations relative to the "top node"
 */
export const getPasteLocations = (nodes: go.ObjectData[]) => {
  const topNode = getTopNode(nodes);
  return (
    nodes?.reduce((acc, node) => {
      if (topNode && node.key === topNode.key) {
        return {
          ...acc,
          [node.key as string]: { x: 0, y: 0 },
        };
      }
      const [tX, tY] = (topNode?.loc ?? '0 0')
        .split(' ')
        .map((v: string) => parseInt(v));
      const [x, y] = node.loc.split(' ').map((v: string) => parseInt(v));
      return {
        ...acc,
        [node.key as string]: { x: x - tX, y: y - tY },
      };
    }, {} as PasteLocations) || {}
  );
};

export const getNodePasteLocation = (
  node: go.ObjectData,
  pasteLocations: PasteLocations,
) => {
  let newX = 0;
  let newY = 0;
  const diagram = getDiagram();
  const center = diagram?.viewportBounds.center;

  if (center) {
    newX = center.x + pasteLocations[node.key].x;
    newY = center.y + pasteLocations[node.key].y;
  } else {
    newX = parseInt(node.layout.loc.split(' ')[0]) + 20;
    newY = parseInt(node.layout.loc.split(' ')[1]) + 20;
  }

  return `${newX} ${newY}`;
};
